import { PostponeStepSchema } from '@feedyou/schema'
import { makePath } from '@feedyou/utils'

import { getUsedDialogs } from './getUsedDialogs'
import { GetSubdialogConnectionsMetadata } from '../../../types'

export const getSubdialogConnectionsMetadata: GetSubdialogConnectionsMetadata<
  PostponeStepSchema
> = (step, parentDialogId) => {
  return [...getUsedDialogs(step)].map(dialog => {
    return {
      parentDialog: parentDialogId,
      childDialog: dialog,
      checkpointLink: makePath(step.id)
    }
  })
}
